<template>
  <div class="mt-4">
    <BaseFormModal ref="base" name="criarCodigoParceiroModal" :centered="true" @show="onShow">
      <template #title>
        {{ $t('criarCodigo') }}
      </template>
      <template #body>
        <input
          ref="quantidade" v-model="quantidade" type="number" class="w-100 form-control"
          :placeholder="$t('quantidade')" required
        >
      </template>
      <template #footer>
        <button type="button" class="btn btn-secondary" @click="$refs.base.hide()">
          <i class="bi bi-x" /> {{ $t("cancelar") }}
        </button>
        <LoadingButton class="btn-primary mw-120" :loading="loading" @click="submit">
          <i class="bi bi-check" /> {{ $t("confirmar") }}
        </LoadingButton>
      </template>
    </BaseFormModal>
  </div>
</template>

<script>
import BaseFormModal from '@/modules/core/components/BaseFormModal.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { criarCodigos } from '../parceiroService';
import { useToast } from 'vue-toastification';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';
import eventbus from '@/modules/core/services/eventbus';

export default {
  components: { BaseFormModal, LoadingButton },
  props: {
    id: { type: String, required: true },
    nome: { type: String, required: true },
  },
  data: () => ({
    loading: false,
    quantidade: '',
  }),
  methods: {
    onShow() { this.quantidade = ''; },
    show() {
      this.$refs.base.show();
      setTimeout(() => this.$refs.quantidade.focus(), 200);
    },
    submit() { !this.loading && this.$refs.base.validate() && this.create(); },
    async create() {
      this.loading = true;
      try {
        if (await criarCodigos(this.id, this.quantidade)) {
          useToast().success('Código(s) criado(s)');
          this.loading = false;
          eventbus.emit('criar-codigo-parceiro');
        } else {
          useToast().error(`O parceiro '${this.nome}' não foi encontrado ou já foi removido.`);
          this.loading = false;
        }
        this.$refs.base.hide();
      } catch (e) {
        useToast().error(ref(computed((_) => i18n.global.t('erroDeConexao'))));
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.mw-120 {
  min-width: 120px;
}
</style>
